const LTI_INTEGRATION_PREFIX = '/ll-lti-integration';

export interface LtiIntegrationUrls {
  jwks: string;
  initiate: string;
  launch: string;
}

export function buildLtiIntegrationUrls(
  host: string,
  platformId: string,
  toolId: string
): LtiIntegrationUrls {
  const base = host.replace(/\/$/, '');
  const toolPath = `${LTI_INTEGRATION_PREFIX}/platforms/${encodeURIComponent(platformId)}/tools/${encodeURIComponent(toolId)}`;

  return {
    jwks: `${base}${LTI_INTEGRATION_PREFIX}/.well-known/keys`,
    initiate: `${base}${toolPath}/initiate`,
    launch: `${base}${toolPath}/launch`,
  };
}

export function formatLtiIntegrationUrlsForCopy(
  urls: LtiIntegrationUrls
): string {
  return [
    `JWKS URL: ${urls.jwks}`,
    `Login initiate URL: ${urls.initiate}`,
    `Launch URL: ${urls.launch}`,
  ].join('\n');
}
